import { render, staticRenderFns } from "./Creatives.vue?vue&type=template&id=253d8aa7&scoped=true&"
import script from "./Creatives.vue?vue&type=script&lang=js&"
export * from "./Creatives.vue?vue&type=script&lang=js&"
import style0 from "./Creatives.vue?vue&type=style&index=0&id=253d8aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d8aa7",
  null
  
)

export default component.exports